/**
 * Política de caducidad del ID token (Cognito) vs renovación con refresh token.
 * Centralizado para tests y para alinear PWA / App con el interceptor axios.
 */

/** El JWT ya no es válido por reloj. */
export function idTokenCalendarExpired(expUnixSec: number, nowUnixSec: number): boolean {
  return nowUnixSec >= expUnixSec;
}

/**
 * Conviene renovar antes de `exp` para evitar 401 y redirecciones bruscas (PWA).
 * `windowSec`: segundos antes de `exp` en los que ya forzamos refresh.
 */
export function idTokenWithinRefreshWindow(expUnixSec: number, nowUnixSec: number, windowSec: number): boolean {
  if (windowSec <= 0) return idTokenCalendarExpired(expUnixSec, nowUnixSec);
  return nowUnixSec >= expUnixSec - windowSec;
}
